import React, { useContext, useState, useEffect, Fragment } from "react";
import { Link } from "react-router-dom";
import { AppContext } from "../Utils/AppContext";
import { useGetFleet } from "../Utils/Fleet";
import Page from "../Layout/Page";
import UserTable from "../Tables/UserTable";
import NotificationsTable from "../Tables/NotificationsTable";
import { FleetFormUpdate } from "../Forms/FleetForm";
var moment = require("moment");

const FleetDetails = ({ location, match, isSuper }) => {
  const context = useContext(AppContext);
  const currentUser = context.state.user;

  const [showFleetForm, setShowFleetForm] = useState(false);

  const [fleet, setFleet] = useState({});
  // const [drivers, setDrivers] = useState([]);

  let companyId;
  let fleetId;

  if (isSuper) {
    companyId = match.params.companyId;
    fleetId = match.params.fleetId;
  } else {
    companyId = location.state.cid;
    fleetId = match.params.fleetId;
  }

  const { loading: loadingFleet, fleet: fleetInfo } = useGetFleet(fleetId, companyId);

  useEffect(() => {
    if (!loadingFleet) {
      setFleet(fleetInfo);
    }
  }, [loadingFleet]);

  var sum = 0;
  var avg = 0;
  if (fleet.drivers) {
    const values = fleet.drivers.map(d => (d ? d.stats.energyLevel : 0));
    values.forEach(value => {
      if (value > 0) sum += value;
    });
    avg = sum > 0 ? Math.round(sum / values.length) : 0;
  }

  return (
    <Page title="Fleet Details">
      <div className="field">
        <p className="field-label">
          <strong>Fleet Name:</strong>
        </p>
        <p className="field-value">{fleet.name}</p>
      </div>
      <div className="field">
        <p className="field-label">
          <strong>Date Created:</strong>
        </p>
        <p className="field-value">{moment(fleet.created).format("MM/DD/YYYY")}</p>
      </div>

      <div className="field">
        <p className="field-label">
          <strong>Customer Name:</strong>
        </p>
        <p className="field-value">{fleet.customerName}</p>
      </div>

      <div className="field">
        <p className="field-label">
          <strong>Location:</strong>
        </p>
        <p className="field-value">{fleet.location}</p>
      </div>

      <div className="field">
        <p className="field-label">
          <strong>Avg. Energy:</strong>
        </p>
        <p className="field-value">{avg}</p>
      </div>

      <br />

      <UserTable
        companyId={companyId}
        fleetId={fleetId}
        userRole="fleet-manager"
        title="Fleet Manager"
        hideRole
        hideEnergy
        hideFilter
        hideCompany
        hideDelete
      />

      <br />

      <UserTable
        hideCompany
        hideRole
        companyId={companyId}
        fleetId={fleetId}
        userRole="driver"
        title="Fleet Drivers"
        hideFilter
        hideDelete
      />

      <br />

      <NotificationsTable companyId={companyId} fleetId={fleetId} />

      {showFleetForm && (
        <Fragment>
          <br />
          <FleetFormUpdate
            companyId={companyId}
            fleetId={fleetId}
            formComplete={() => {
              setShowFleetForm(false);
            }}
          />

          <button
            type="button"
            onClick={() => {
              setShowFleetForm(false);
            }}
          >
            Cancel
          </button>
        </Fragment>
      )}

      {!showFleetForm && (
        <Fragment>
          <br />
          <button
            type="button"
            onClick={() => {
              setShowFleetForm(true);
            }}
          >
            Edit Fleet
          </button>
        </Fragment>
      )}
    </Page>
  );
};

export default FleetDetails;
